/**
 * Public constants.
 */

// Date picker controller
export const DATEPICKER_CONTROLLER_ID = 'Datepicker';

// Form controller
export const FORM_CONTROLLER_ID = 'Form';
export const FORM_EVENT = {
  beforeSend: 'form:beforeSend',
  enableFields: 'form:enableFields',
  errorSummary: 'form:errorSummary',
  formsetFormAdded: 'form:formsetFormAdded',
  formsetFormRemoved: 'form:formsetFormRemoved',
  response: 'form:response',
  responseHttpError: 'form:responseHttpError',
  send: 'form:send',
};
export const FORM_POST_EVENT_TYPE = 'POST_FORM';
export const FORM_SUBMITTING_DATA_ATTR = 'submitting';

// Lightbox controller
export const LIGHTBOX_CONTROLLER_ID = 'Lightbox';
export const LIGHTBOX_EVENT = {
  ajaxError: 'lightbox:ajaxError',
  back: 'lightbox:back',
  close: 'lightbox:close',
  open: 'lightbox:open',
  showItem: 'lightbox:showItem',
};

// PageUpdater controller
export const PAGE_UPDATER_CONTROLLER_ID = 'PageUpdater';
export const PAGE_UPDATER_EVENT = {
  update: 'pageUpdater:update',
};

// Tabs controller
export const TABS_CONTROLLER_ID = 'Tabs';

// Toggle controller
export const TOGGLE_CONTROLLER_ID = 'Toggle';
export const TOGGLE_EVENT = {
  toggle: 'toggle:toggle',
};
